export const validationErrors = {
  REQUIRED_FIELD: 'This field is required',
  EMAIL_INVALID: 'Invalid email address',
  PASSWORD_MIN: 'Password is too short - should be at least 8 symbols',
  PASSWORD_VALID:
    'Password must only contain Latin letters and number and at least one uppercase letter',
  PASSWORD_CONFIRMATION_MATCH: 'The passwords do not match!',
  REQUIRED_CHECKBOXES: 'Choose at least one',
} as const;
